import MUButton from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { FavoriteBorderRounded, FavoriteRounded } from "@material-ui/icons";
import AppContext from "context/AppContext";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Link, useHistory, useParams } from "react-router-dom";
import Button from "shared/components/Buttons/Button";
import CardUser from "shared/components/CardUser/CardUser";
import CodeBlock from "shared/components/CodeBlock/CodeBlock";
import Feedbacks from "shared/components/Feedbacks/Feedbacks";
import apiCalls from "shared/utils/apiCalls";
import { throttle } from "shared/utils/throttle";
import SolutionDetailsSkeleton from "../SolutionDetailsSkeleton/SolutionDetailsSkeleton";
import styles from "./SolutionDetails.module.scss";

const SolutionDetails = () => {
  const [solution, setSolution] = useState<any>();
  const { state, dispatch } = useContext(AppContext);
  const [pinLoading, setPinLoading] = useState<boolean>(false);

  const { id } = useParams();

  const history = useHistory();

  const deleteSolution = async () => {
    const res = await apiCalls(
      {
        method: "delete",
        url: `/solutions/${id}`,
      },
      dispatch
    );

    if (res) {
      history.push(`/solutions`);
    }
  };

  const pinSolution = async () => {
    setPinLoading(true);
    const res = await apiCalls(
      {
        method: "post",
        url: `/solutions/pin/${id}`,
      },
      dispatch
    );

    if (res) {
      setSolution(res.data);
    }

    setPinLoading(false);
  };

  useEffect(() => {
    const getSolution = async () => {
      const res = await apiCalls(
        {
          method: "get",
          url: `/solutions/${id}`,
        },
        dispatch
      );

      if (res) {
        setSolution(res.data);
      }
    };

    getSolution();
    // eslint-disable-next-line
  }, [id]);

  const like = async () => {
    const res = await apiCalls(
      {
        method: "put",
        url: `/solutions/${id}/like`,
      },
      dispatch
    );

    if (res) {
      setSolution(res.data);
    }
  };

  const likeSolution = () => {
    throttle(like, 1000);
  };

  const findChallenge = (challengeId: string) => {
    if (!state.challenges) {
      return;
    }

    return state.challenges.find(({ id }: any) => challengeId === id);
  };

  const challenge = findChallenge(solution?.challengeId);

  return (
    <>
      <div className={styles.solutionDetails}>
        {solution ? (
          <>
            <div className={styles.solutionDetails_title} id="summary">
              <h1>{solution.title}</h1>

              <p
                style={{
                  fontSize: "var(--text-xs)",
                  fontWeight: "normal",
                  fontFamily: "var(--heading-font-family)",
                  display: "inline-block",
                  marginRight: "var(--space-xs)",
                }}
              >
                {moment(solution.submittedAt).toNow()}
              </p>
              <span
                style={{
                  color: "var(--grey-5)",
                }}
              >
                .
              </span>
              <p
                style={{
                  fontSize: "var(--text-xs)",
                  fontWeight: "normal",
                  fontFamily: "var(--heading-font-family)",
                  display: "inline-block",
                  marginLeft: "var(--space-xs)",
                  marginRight: "var(--space-xs)",
                }}
              >
                edited
              </p>

              {solution.pinned && (
                <>
                  <span
                    style={{
                      color: "var(--grey-5)",
                    }}
                  >
                    .
                  </span>
                  <p
                    style={{
                      fontSize: "var(--text-xs)",
                      fontWeight: "normal",
                      fontFamily: "var(--heading-font-family)",
                      display: "inline-block",
                      marginLeft: "var(--space-xs)",
                    }}
                  >
                    pinned
                  </p>
                </>
              )}
            </div>

            <div className={styles.solutionDetails_flexRow}>
              {!solution.likes?.includes(state.user?.uid) ? (
                <button
                  aria-label="like"
                  className={styles.solutionDetails_likeButton}
                  onClick={likeSolution}
                >
                  <FavoriteBorderRounded fontSize="inherit" />
                  <p>{solution.likes?.length || 0}</p>
                </button>
              ) : (
                <button
                  aria-label="like"
                  className={styles.solutionDetails_likedButton}
                  onClick={likeSolution}
                >
                  <FavoriteRounded fontSize="inherit" />
                  <p>{solution.likes?.length || 0}</p>
                </button>
              )}

              <CardUser user={solution.user} />

              <div style={{ flexGrow: 1 }} />

              {state.user?.role === "admin" && (
                <MUButton
                  variant="text"
                  type="button"
                  style={{
                    textTransform: "lowercase",
                    fontFamily: "var(--heading-font-family)",
                    color: "var(--grey-5)",
                    border: "1px solid var(--grey-5)",
                    fontSize: "var(--text-xs)",
                    marginLeft: "var(--space-md)",
                  }}
                  size="small"
                  onClick={deleteSolution}
                >
                  delete
                </MUButton>
              )}

              {solution.uid === state.user?.uid && (
                <>
                  <div
                    style={{
                      marginLeft: "var(--space-sm)",
                    }}
                  >
                    <Button
                      type="button"
                      style={{
                        textTransform: "capitalize",
                        fontFamily: "var(--heading-font-family)",
                      }}
                      size="small"
                      onClick={pinSolution}
                      loading={pinLoading}
                      buttonVariant="default"
                    >
                      {solution.pinned ? "unpin" : "pin"}
                    </Button>
                  </div>

                  <div
                    style={{
                      marginLeft: "var(--space-sm)",
                    }}
                  >
                    <Button
                      type="button"
                      style={{
                        textTransform: "capitalize",
                        fontFamily: "var(--heading-font-family)",
                      }}
                      size="small"
                      onClick={() =>
                        history.push(
                          `/challenges/${solution.challengeId}/submit-solution/${solution.id}`
                        )
                      }
                      buttonVariant="default"
                    >
                      edit
                    </Button>
                  </div>
                </>
              )}
            </div>

            <div className={styles.solutionDetails_pharagraph}>
              <div className={styles.challengeDetails_description}>
                <ReactMarkdown
                  renderers={{ code: CodeBlock }}
                  source={solution.description}
                ></ReactMarkdown>
              </div>
            </div>

            <div className={styles.solutionDetails_previewHeader} id="preview">
              <h2>Preview</h2>
              <div className={styles.solutionDetails_buttons}>
                <Button
                  aria-label="demo"
                  textTransform="capitalize"
                  buttonVariant="secondary"
                  onClick={() => window.open(solution.demoUrl)}
                >
                  Demo
                </Button>

                <Button
                  aria-label="code"
                  textTransform="capitalize"
                  buttonVariant="default"
                  onClick={() => window.open(solution.repoUrl)}
                >
                  Code
                </Button>
              </div>
            </div>

            <div className={styles.solutionDetails_iframe}>
              <iframe src={solution.demoUrl} title={solution.title}></iframe>
            </div>

            <div className={styles.solutionDetails_challenge}>
              <Link to={`/challenges/${solution.challengeId}`}>
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={12} sm={5}>
                    <div
                      className={styles.solutionDetails_challenge_imgWrapper}
                    >
                      <img
                        loading="lazy"
                        src={challenge?.thumbnailImage}
                        alt={challenge?.name}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={7}>
                    <h3>{challenge?.name}</h3>

                    {challenge?.brief && (
                      <ReactMarkdown
                        renderers={{ code: CodeBlock }}
                        source={challenge?.brief}
                      ></ReactMarkdown>
                    )}
                  </Grid>
                </Grid>
              </Link>
            </div>
          </>
        ) : (
          <SolutionDetailsSkeleton />
        )}

        {solution?.feedbackRequest && (
          <div className={styles.solutionDetails_feedbackRequest}>
            <div className={styles.solutionDetails_feedbackRequest_user}>
              <CardUser user={solution?.user} small detailsHidden />
              <div className={styles.solutionDetails_feedbackRequest_name}>
                <span>{solution?.user?.name}</span>
              </div>
            </div>

            <div className={styles.solutionDetails_feedbackRequest_content}>
              {solution?.feedbackRequest}
            </div>
          </div>
        )}

        <div className={styles.solutionDetails_feedbacks} id="feedbacks">
          {solution && (
            <Feedbacks
              parentId={id}
              challengeId={solution?.challengeId}
              solution={solution}
            ></Feedbacks>
          )}
        </div>
      </div>
    </>
  );
};

export default SolutionDetails;
